import { SelectionEvent } from '../../../../core/domain/events/selection_event';
import { Patient } from '../patient';

export class PatientSelectionEvent extends SelectionEvent<Patient> {}

export class PatientSelectionArchived extends PatientSelectionEvent {}

export class PatientSelectionActivated extends PatientSelectionEvent {}
